import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import SectionInfo from 'components/FrictionlessCheckout/LayoutCard/SectionInfo/SectionInfo';
import SectionInfoEN from 'components/FrictionlessCheckout/LayoutCard/SectionInfo/locales/SectionInfo_en_US';
import SectionInfoFR from 'components/FrictionlessCheckout/LayoutCard/SectionInfo/locales/SectionInfo_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(SectionInfoEN, SectionInfoFR);

const localizationSelector = createStructuredSelector({
    change: getTextFromResource(getText, 'change')
});

const fields = createSelector(localizationSelector, localization => {
    return {
        localization
    };
});

const withSectionProps = wrapHOC(connect(fields, null));

export default withSectionProps(SectionInfo);
